<template>
  <footer class="container"></footer>
</template>

<script>
export default {};
</script>